<template>
<div class="operators">
  <el-button size="small" @click="openDialog" type="primary">新建</el-button>
  <el-dialog :visible.sync="dialogVisible" title="新建网关" width="450px" v-if="dialogVisible" :close="close">
    <el-form ref="form" label-width="80px" :rules="rules" :model="newGateway">
      <el-form-item label="网关名称" prop="name">
        <el-input v-model="newGateway.name"></el-input>
      </el-form-item>
      <el-form-item label="网关类型" prop="type">
        <el-select v-model="newGateway.type">
          <el-option label="MODBUS" value="MODBUS"></el-option>
          <el-option label="DTU" value="DTU"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="create" :disabled="disableButton">新建</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</div>
</template>

<script>
import { createGateway } from '@/api/device-controller'

export default {
  name: 'GatewayOperators',
  props: ['API'],
  data() {
    return {
      dialogVisible: false,
      disableButton: false,
      newGateway: {
        name: '',
        type: 'MODBUS'
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 3, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    close() {
      this.newGateway.name = ''
    },
    openDialog() {
      this.dialogVisible = true
    },
    async create() {
      this.newGateway.name = this.newGateway.name.trim()
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          try {
            this.disableButton = true
            await createGateway(this.newGateway.name, this.newGateway.type)
            this.$message.success('创建成功')
            this.disableButton = false
            this.dialogVisible = false
            this.newGateway = {
              name: '',
              type: 'MODBUS'
            }
            await this.API.getData()
          } catch (error) {
            this.$message.error('网关名称重复')
            this.disableButton = false
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
